/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ServiceModelDetail
 */
export interface ServiceModelDetail {
    /**
     * AKA Priority. Eg "SL1 Critical"
     * @type {string}
     * @memberof ServiceModelDetail
     */
    name?: string;
    /**
     * eg 1-4, 1=highest
     * @type {number}
     * @memberof ServiceModelDetail
     */
    serviceLevel?: number;
    /**
     * Free text description of the service level, eg "1 hour" or "Reasonable endeavours"
     * @type {string}
     * @memberof ServiceModelDetail
     */
    timeToResponse?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceModelDetail
     */
    timeToSite?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceModelDetail
     */
    timeToResolution?: string;
}

/**
 * Check if a given object implements the ServiceModelDetail interface.
 */
export function instanceOfServiceModelDetail(
    value: object,
): value is ServiceModelDetail {
    return true;
}

export function ServiceModelDetailFromJSON(json: any): ServiceModelDetail {
    return ServiceModelDetailFromJSONTyped(json, false);
}

export function ServiceModelDetailFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ServiceModelDetail {
    if (json == null) {
        return json;
    }
    return {
        name: json["name"] == null ? undefined : json["name"],
        serviceLevel:
            json["serviceLevel"] == null ? undefined : json["serviceLevel"],
        timeToResponse:
            json["timeToResponse"] == null ? undefined : json["timeToResponse"],
        timeToSite: json["timeToSite"] == null ? undefined : json["timeToSite"],
        timeToResolution:
            json["timeToResolution"] == null
                ? undefined
                : json["timeToResolution"],
    };
}

export function ServiceModelDetailToJSON(
    value?: ServiceModelDetail | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        name: value["name"],
        serviceLevel: value["serviceLevel"],
        timeToResponse: value["timeToResponse"],
        timeToSite: value["timeToSite"],
        timeToResolution: value["timeToResolution"],
    };
}
